import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import {
  Loading,
  MultiSelect,
  Select,
  SelectItem,
  TextField,
  CkEditor,
  CheckBox,
  TextArea,
} from "components/form";
import { required, validationWrapper } from "lib/formValidations";
import { useCore } from "store/core";
import { useWizard } from "store/wizard";
import Modal from "components/Modal";
import {
  generate_uuid,
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import VideoUploader from "lib/streamingUploader";

const CafeProductDetail = (props) => {
  const core = useCore();
  const wizard = useWizard();
  const [casts, setCasts] = useState([]);
  const [showAddCast, setShowAddCast] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);

  useEffect(() => {
    if (core.countries && core.countries.length < 1) {
      core.dispatch(core.getCountries());
    }
    if (core.genres && core.genres.length < 1) {
      core.dispatch(core.getGenres());
    }
    if (core.languages && core.languages.length < 1) {
      core.dispatch(core.getLanguages());
    }
    if (core.casts && core.casts.length < 1) {
      core.dispatch(core.getCasts());
    }
    if (core.activityFields && core.activityFields.length < 1) {
      core.dispatch(core.getActivityFields());
    }
    if (
      wizard.product &&
      wizard.product.product_detail &&
      wizard.product.product_detail.casts
    ) {
      setCasts(
        wizard.product.product_detail.casts.map((i) => ({
          uuid: i.id,
          cast_id: { label: i.cast && i.cast.full_name, value: i.cast_id },
          activity_field_id: {
            label: i.activity_field && i.activity_field.name,
            value: i.activity_field_id,
          },
        }))
      );
    }
  }, []);

  const _renderCasts = () => {
    return casts.map((item) => (
      <tr className="text-center">
        <td>{item.cast_id.label}</td>
        <td>{item.activity_field_id.label}</td>
        <td>
          <button
            type="button"
            onClick={() => {
              setCasts(casts.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </td>
      </tr>
    ));
  };
  if (wizard.load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <AddCast
        close={() => setShowAddCast(false)}
        show={showAddCast}
        submit={(values) => {
          setCasts([...casts, values]);
        }}
      />

      <div className="font-medium text-base">اطلاعات تکمیلی</div>
      <Formik
        key="fromik_p_detail"
        initialValues={
          wizard.product && wizard.product.product_detail
            ? {
                ...transformTranslateServerValues(
                  wizard.product.product_detail
                ),
                not_show_in_new: wizard.product.not_show_in_new || false,
                show_source: !!wizard.product.product_detail.video_source_id,
                genres:
                  wizard.product.product_detail.genres &&
                  wizard.product.product_detail.genres.map((i) => i.id),
                subtitle_languages:
                  wizard.product.product_detail.subtitle_languages &&
                  wizard.product.product_detail.subtitle_languages.map(
                    (i) => i.id
                  ),
              }
            : {
                casts: [],
                genres: [],
                screening_ticket_life: 8,
                country_id: 118,
              }
        }
        onSubmit={async (values, { setSubmitting }) => {
          await props.submitStep({
            ...transformTranslateFromValues(values),
            casts: casts.map((i) => ({
              cast_id: i.cast_id.value,
              activity_field_id: i.activity_field_id.value,
            })),
          });
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values, setFieldValue }) => (
          <Form>
            <UploadFile
              close={() => setShowFileUpload(false)}
              show={showFileUpload}
              completed={(id) => {
                setFieldValue("video_source_id", id);
              }}
            />
            <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
              <div className="grid grid-cols-12 gap-4 gap-y-3 col-span-7">
                <div className="intro-y col-span-12 sm:col-span-12">
                  <Field
                    label="عنوان :"
                    name="title"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <div className="intro-y mt-2">
                    <Field
                      label="عنوان انگلیسی :"
                      name="_en*title*text"
                      component={TextField}
                      //  validate={(value) => validationWrapper(value, required)}
                    />
                  </div>
                </div>
                <div className="intro-y col-span-12 sm:col-span-12">
                  <Field
                    label="پخش آنلاین"
                    name="show_source"
                    component={CheckBox}
                  />
                </div>
                {(values.show_source || values.video_source_id) && (
                  <>
                    <div className="intro-y col-span-12 sm:col-span-3">
                      <Field
                        label="منبع سرور ویدئو :"
                        name="video_source_type"
                        component={Select}
                        options={[
                          { value: "HASHURE_STRIMING", label: "هاشور" },
                          { value: "DORDIS", label: "دوردیس" },
                          { value: "VOD", label: "وی او دی" },
                        ]}
                        validate={(value) => validationWrapper(value, required)}
                      />
                    </div>
                    <div className="intro-y col-span-12 sm:col-span-3 flex items-center gap-x-2">
                      <Field
                        label="ایدی/اسلاگ سورس فیلم: "
                        name="video_source_id"
                        component={TextField}
                        validate={(value) => validationWrapper(value, required)}
                      />
                      {values.video_source_type == "HASHURE_STRIMING" && (
                        <button
                          className="btn btn-sm btn-primary h-6"
                          type="button"
                          onClick={() => {
                            setShowFileUpload(true);
                          }}
                        >
                          آپلود
                        </button>
                      )}
                    </div>
                    <div className="intro-y col-span-12 sm:col-span-6">
                      <Field
                        label="نمایش لوگو"
                        name="show_player_logo"
                        component={CheckBox}
                      />
                    </div>
                    <div className="intro-y col-span-12 sm:col-span-3">
                      <Field
                        label="زمان شروع تیتراژ :"
                        name="starting_title_time"
                        component={TextField}
                        type="number"
                      />
                    </div>
                    <div className="intro-y col-span-12 sm:col-span-3">
                      <Field
                        label="زمان پایان تیتراژ :"
                        name="ending_title_time"
                        component={TextField}
                        type="number"
                      />
                    </div>
                  </>
                )}
                <div className="intro-y col-span-12 sm:col-span-6">
                  <Field
                    label="نمایش کشور"
                    name="show_country"
                    component={CheckBox}
                  />
                </div>
                <div className="intro-y col-span-12 sm:col-span-6">
                  <Field
                    label="عدم نمایش در تازه ها"
                    name="not_show_in_new"
                    component={CheckBox}
                  />
                </div>
                <div className="intro-y col-span-12 sm:col-span-6">
                  <Field
                    label="کشور سازنده :"
                    name="country_id"
                    component={Select}
                    validate={(value) => validationWrapper(value, required)}
                    options={core.countries || []}
                  />
                </div>
                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-3">
                  <Field
                    label="تاریخ انتشار(شمسی) :"
                    name="release_date"
                    component={TextField}
                  />
                </div>
                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-3">
                  <Field
                    label="تاریخ انتشار(میلادی) :"
                    name="_en*release_date*text"
                    component={TextField}
                  />
                </div>
                {wizard.type != "Serie" && (
                  <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-3">
                    <Field
                      label="مدت زمان فیلم :"
                      name="duration"
                      component={TextField}
                      type="number"
                    />
                  </div>
                )}
                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-3">
                  <Field
                    label="امتیاز IMDB :"
                    name="imdb_rate"
                    component={TextField}
                    type="number"
                  />
                </div>

                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-3">
                  <Field
                    label="محدودیت سنی:"
                    name="age_restriction"
                    component={TextField}
                  />
                </div>

                {wizard.type == "Screening" && (
                  <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-3">
                    <Field
                      label="اعتبار بلیت(ساعت) :"
                      name="screening_ticket_life"
                      component={TextField}
                      type="number"
                    />
                  </div>
                )}
                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-3">
                  <Field
                    label="ویژه"
                    name="featured"
                    component={CheckBox}
                    type="number"
                  />
                </div>

                <div className="intro-y col-span-12 sm:col-span-12">
                  <Field
                    label="گویش :"
                    name="languages"
                    component={TextField}
                  />
                  <div className="intro-y mt-2">
                    <Field
                      label="گویش انگلیسی :"
                      name="_en*languages*text"
                      component={TextField}
                    />
                  </div>
                  <Field
                    label="زیرنویس دارد؟"
                    name="has_subtitle"
                    component={CheckBox}
                    type="number"
                  />
                  {core.languagesLoad ? (
                    <loading />
                  ) : (
                    values.has_subtitle && (
                      <Field
                        label="زبان زیرنویس:"
                        name="subtitle_languages"
                        valueOnly={true}
                        component={MultiSelect}
                        options={core.languages || []}
                      />
                    )
                  )}
                </div>
              </div>
              <div className="flex flex-col col-span-5">
                <div className="intro-y">
                  {core.genrsLoad ? (
                    <loading />
                  ) : (
                    values.genres && (
                      <Field
                        label="ژانر ها :"
                        name="genres"
                        valueOnly={true}
                        component={MultiSelect}
                        options={core.genres || []}
                      />
                    )
                  )}
                </div>
                <div className="intro-y mt-3">
                  <div className="flex justify-between items-center">
                    <h3>عوامل :</h3>
                    <button
                      className="btn btn-sm btn-primary"
                      type="button"
                      onClick={() => setShowAddCast(true)}
                    >
                      افزودن عوامل
                    </button>
                  </div>
                  <hr className="my-2" />
                  <div className="border rounded">
                    <table className="table text-sm">
                      <thead>
                        <tr className="text-center">
                          <th>نام</th>
                          <th>زمینه فعالیت</th>
                          <th>عملیات</th>
                        </tr>
                      </thead>
                      <tbody>{_renderCasts()}</tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                <div className="intro-y">
                  <Field
                    label="خلاصه فیلم :"
                    name="short_synopsis"
                    component={CkEditor}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="داستان فیلم :"
                    name="synopsis"
                    component={CkEditor}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="خلاصه انگلیسی فیلم :"
                    name="_en*short_synopsis*text"
                    component={CkEditor}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="داستان انگلیسی فیلم :"
                    name="_en*synopsis*text"
                    component={CkEditor}
                  />
                </div>
              </div>
              <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                <div className="intro-y">
                  <Field
                    label="توضیحات سئو(max 160 characters):"
                    name="seo_desc"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="توضیحات انگلیسی سئو(max 160 characters):"
                    name="_en*seo_desc*text"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="کلمات کلیدی سئو(مانند:سریال,اکشن):"
                    name="seo_keywords"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="کلمات کلیدی انگلیسی سئو(مانند:serie,action):"
                    name="_en*seo_keywords*text"
                    component={TextArea}
                  />
                </div>
              </div>
              <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
                <button
                  className="btn btn-secondary w-24"
                  type="button"
                  onClick={() => wizard.dispatch(wizard.previous())}
                  disabled={isSubmitting}
                >
                  قبلی
                </button>
                <button
                  className="btn btn-primary w-24 mr-2"
                  disabled={isSubmitting}
                  type="submit"
                >
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  className="btn btn-secondary w-24 mr-2"
                  type="button"
                  onClick={() => {
                    wizard.dispatch(wizard.next());
                  }}
                  disabled={isSubmitting}
                >
                  بعدی
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CafeProductDetail;

export function AddCast(props) {
  const core = useCore();
  return (
    <Modal show={props.show} handleClose={props.close} title="افزودن عوامل">
      <Formik
        key="fromik_p_casts"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-2 md:gap-3">
                {core.castsLoad ? (
                  <Loading />
                ) : (
                  <div>
                    <Field
                      placeholder="عامل"
                      label="عامل :"
                      name="cast_id"
                      component={SelectItem}
                      validate={(value) => validationWrapper(value, required)}
                      options={core.casts || []}
                    />
                  </div>
                )}
                {core.activityFieldsLoad ? (
                  <Loading />
                ) : (
                  <div>
                    <Field
                      placeholder="زمینه فعالیت"
                      label="زمینه فعالیت :"
                      name="activity_field_id"
                      component={SelectItem}
                      validate={(value) => validationWrapper(value, required)}
                      options={core.activityFields || []}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function UploadFile(props) {
  const [fileCount, setFileCount] = useState(0);
  const [totalSize, setTotalSize] = useState(0);
  const [totalPercent, setTotalPercent] = useState(0);
  const [chunkInfo, setChunkInfo] = useState("");
  const [videoInfo, setVideoInfo] = useState("");
  const [uploading, setUploading] = useState(false);

  const _resetState = () => {
    setFileCount(0);
    setTotalSize(0);
    setChunkInfo("");
    setVideoInfo("");
  };
  const uploadFile = (file) => {
    const uniqueId =
      Date.now().toString(36) + Math.random().toString(36).substring(2);
    const uploader = new VideoUploader({
      file: file,
      videoId: uniqueId,
      // uploadToken: "to5PoOjCz98FdLGnsrFflnYo",
      //chunkSize: 1024*1024*10, // 10MB
      chunkSize: 1024 * 1024 * 2, // 10MB
      retries: 10,
    });
    setUploading(true);
    uploader.onProgress((event) => {
      var percentComplete = Math.round(
        (event.currentChunkUploadedBytes / event.chunksBytes) * 100
      );
      var totalPercentComplete = Math.round(
        (event.uploadedBytes / event.totalBytes) * 100
      );
      setChunkInfo(
        "Chunk # " +
          event.currentChunk +
          " is " +
          percentComplete +
          "% uploaded..."
      );
      setTotalPercent(totalPercentComplete);
    });
    uploader.upload().then((video) => {
      console.log(video);
      let url = video.url;
      setVideoInfo(url);
      props.completed(url);
      _resetState();
      props.close();
    });
  };

  const updateUpload = (e) => {
    let nBytes = 0,
      oFiles = e.target.files,
      nFiles = oFiles.length;
    for (let nFileId = 0; nFileId < nFiles; nFileId++) {
      nBytes += oFiles[nFileId].size;
      uploadFile(oFiles[nFileId]);
    }
    let sOutput = nBytes + " bytes";
    // optional code for multiples approximation
    const aMultiples = ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    for (
      let nMultiple = 0, nApprox = nBytes / 1024;
      nApprox > 1;
      nApprox /= 1024, nMultiple++
    ) {
      sOutput =
        nApprox.toFixed(3) +
        " " +
        aMultiples[nMultiple] +
        " (" +
        nBytes +
        " bytes)";
    }
    // end of optional code
    setFileCount(nFiles);
    setTotalSize(sOutput);
    setVideoInfo(".....");
    setChunkInfo(".....");
  };
  return (
    <Modal show={props.show} handleClose={props.close} title="اپلود ویدیو">
      <div className="modal-body gap-y-3">
        <div className="intro-x">
          <form name="uploadForm" style={{ direction: "ltr" }}>
            <input
              id="uploadInput"
              className="form-control
    block
    w-full
    px-3
    py-1.5
    text-base
    font-normal
    text-gray-700
    bg-white bg-clip-padding
    border border-solid border-gray-300
    rounded
    transition
    ease-in-out
    m-0
    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              type="file"
              name="myFiles"
              onChange={updateUpload}
            />
            <br />

            {uploading && (
              <>
                <div class="relative pt-1">
                  <div class="flex mb-2 items-center justify-between">
                    <div>
                      <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 bg-emerald-200">
                        {chunkInfo}
                      </span>
                    </div>
                    <div class="text-right">
                      <span class="text-xs font-semibold inline-block text-emerald-600">
                        {totalPercent}%
                      </span>
                    </div>
                  </div>
                  <div class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-emerald-200">
                    <div
                      style={{ width: totalPercent + "%" }}
                      class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-emerald-500"
                    ></div>
                  </div>
                </div>
                Total size: <span id="fileSize">{totalSize}</span>
              </>
            )}
          </form>
        </div>
      </div>
      <div className="modal-footer text-right">
        <button
          type="button"
          onClick={props.close}
          className="btn btn-outline-secondary w-20 mr-1"
        >
          انصراف
        </button>
      </div>
    </Modal>
  );
}
